import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-toll-free-notification",
  templateUrl: "./toll-free-notification.component.html",
  styleUrls: ["./toll-free-notification.component.scss"],
})
export class TollFreeNotificationComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {}

  closeModal = () => {
    this.activeModal.close();
  };

  mailTo(email: string) {
    window.open(`mailto:${email}`, "_system");
  };
}
